import api from './api';

const state = {
	success: false,
	error: false,
	loading: false,
	roles: [],
};
const getters = {};
const mutations = {
	showSuccess(state) {
		state.success = true;
	},
	hideSuccess(state) {
		state.success = false;
	},
	showError(state) {
		state.error = true;
	},
	hideError(state) {
		state.error = false;
	},
	setRoles(state, { roles }) {
		state.roles = roles;
	},
	startLoading(state) {
		state.loading = true;
	},
	stopLoading(state) {
		state.loading = false;
	},
};
const actions = {
	async deleteAdmin({ state, commit, rootGetters, dispatch }, admin) {
		var result;
		if (!admin.deleted) {
			result = api.deleteAdmin(admin);
		} else {
			admin.deleted = false;
			result = api.editAdmin(admin);
		}
		return result
			.then(() => {
				commit('showSuccess');
				window.setTimeout(() => {
					commit('hideSuccess');
				}, 1500);
				dispatch('admins/load', null, { root: true });
			})
			.catch((err) => {
				const message = err.response.data.message;
				commit('showError');
				window.setTimeout(() => {
					commit('hideError');
				}, 3000);
				return message;
			});
	},
	async updateAdmin({ state, commit, rootGetters, dispatch }, admin) {
		var result;
		if (admin.id) {
			result = api.editAdmin(admin);
		} else {
			result = api.addAdmin(admin);
		}
		return result
			.then(() => {
				commit('showSuccess');
				window.setTimeout(() => {
					commit('hideSuccess');
				}, 1500);
				dispatch('admins/load', null, { root: true });
			})
			.catch((err) => {
				const message = err.response.data.message;
				commit('showError');
				window.setTimeout(() => {
					commit('hideError');
				}, 3000);
				return message;
			});
	},
	async loadAdmin({ state, commit, rootGetters }, id) {
		commit('startLoading');
		return api
			.loadAdmin(id)
			.then((response) => {
				const admin = response.data;
				// commit('setUsers', { admins });
				commit('stopLoading');
				return admin;
			})
			.catch((err) => {
				console.log('Error loading admin:');
				console.log(err);
				commit('stopLoading');
			});
	},
	async getRoles({ commit }) {
		return api.getRoles().then((response) => {
			const roles = response.data;
			commit('setRoles', { roles });
		});
	},
};
export default {
	namespaced: true,
	state,
	getters,
	actions,
	mutations,
};
